var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseDeformer } from "./BaseDeformer";
import { DEFORMER_MANIP_ENUM } from "../enums";
var CurveDeformer = /** @class */ (function (_super) {
    __extends(CurveDeformer, _super);
    function CurveDeformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deformerType = [DEFORMER_MANIP_ENUM.VERTEX];
        _this.pathOffset = 0.0;
        _this.pathSegment = 1.0;
        _this.spineOffset = 0.0;
        _this.spineLength = 0.0;
        _this.flow = 1;
        return _this;
    }
    Object.defineProperty(CurveDeformer.prototype, "animatableProperties", {
        get: function () {
            return [
                'pathOffset',
                'pathSegment',
                'spineOffset',
                'spineLength',
                'flow'
            ];
        },
        enumerable: false,
        configurable: true
    });
    CurveDeformer.prototype._uniforms = function () {
        return {
            texture: this.texture,
            pathOffset: this.pathOffset,
            pathSegment: this.pathSegment,
            spineOffset: this.spineOffset,
            spineLength: this.spineLength,
            flow: this.flow,
        };
    };
    CurveDeformer.prototype._vertexHeader = function () {
        return "\n        uniform sampler2D texture;\n        uniform float pathOffset;\n        uniform float pathSegment;\n        uniform float spineOffset;\n        uniform float spineLength;\n        uniform int flow;\n        float textureLayers = 4.; // look up takes (i + 0.5) / textureLayers\n        ";
    };
    CurveDeformer.prototype._vertBody = function () {
        return "\n        vec3 getVertexPosition".concat(this.index, "(vec3 inputPosition) {\n            vec4 worldPos = vec4(inputPosition.xyz, 1.0);\n            bool bend = flow > 0;\n            float xWeight = bend ? 0.0 : 1.0;\n            float spinePortion = bend ? (worldPos.x + spineOffset) / spineLength : 0.;\n            float mt = spinePortion * pathSegment + pathOffset;\n            \n            vec3 spinePos = texture2D(texture, vec2(mt, (0.5) / textureLayers)).xyz;\n            vec3 a = texture2D(texture, vec2(mt, (1. + 0.5) / textureLayers)).xyz;\n            vec3 b = texture2D(texture, vec2(mt, (2. + 0.5) / textureLayers)).xyz;\n            vec3 c = vec3(0.0, 0.0, 1.0);\n            mat3 basis = mat3(a, b, c);\n            \n            vec3 transformed = basis\n                * vec3(worldPos.x * xWeight, worldPos.y * 1., 0)\n                + spinePos;\n                \n            return transformed;\n        }");
    };
    return CurveDeformer;
}(BaseDeformer));
export { CurveDeformer };
